function openPopupModal(modalId){
    coveringPanel = document.querySelector(".modal-covering-panel#" + modalId);
    modal = document.querySelector(".modal-popup#" + modalId);

    if (!coveringPanel){
        return;
    }

    coveringPanel.style.display = 'unset';
    modal.style.display = 'unset';
}

function closePopupModal(modalId){
    coveringPanel = document.querySelector(".modal-covering-panel#" + modalId);
    modal = document.querySelector(".modal-popup#" + modalId);

    if (!coveringPanel){
        return;
    }

    coveringPanel.style.display = 'none';
    modal.style.display = 'none';
}